<div class="toast">
  <div class="toast-inner">
    <div class="toast-icon">
      <span class="{{ toastPackage.toastType }}"></span>
    </div>
    <div class="toast-message">
      <h6 class="m-0" *ngIf="title">{{ title }}</h6>
      <p class="m-0" *ngIf="message">{{ message }}</p>
    </div>
  </div>
  <div class="toast-actions" *ngIf="options.closeButton">
    <button (click)="remove()" class="btn btn-link"><span class="bi bi-x"></span></button>
  </div>
</div>
